import { Flex, Image, Stack } from "@chakra-ui/react";

import { ProductDetails } from "helpers/fakeData";
import { useGetMarketPlaceProduct } from "hooks/useGetMarketPlaceProduct";
import ProductDescription from "@features/marketplace/catalog/ProductDescription";
import { useCallback, useMemo, useState } from "react";

interface Props {
  product: ProductDetails;
  color?: string;
}

interface PropsWithId {
  productId: string;
  onAddToCart?: (product: ProductDetails) => void;
}

const ProductInfo = ({ productId, onAddToCart }: PropsWithId) => {
  const product = useGetMarketPlaceProduct(productId);
  const [color, setColor] = useState<string | undefined>(product?.defaultColor);

  const handleSelectColor = useCallback((color: string) => {
    setColor(color);
    console.log("color", color);
  }, []);

  if (product == null) {
    return null;
  }

  return (
    <Stack
      direction={{ base: "row", mdDown: "column" }}
      gap={6}
      width="full"
      justifyContent="center"
    >
      <ProductImage color={color} product={product} />
      <ProductDescription
        product={product}
        onAddToCart={onAddToCart}
        onSelectColor={handleSelectColor}
      />
    </Stack>
  );
};

const ProductImage = ({ product, color }: Props) => {
  const image = useMemo(() => {
    if (color == null) {
      return product.defaultImage;
    }
    return product.imagesByColor?.[color] ?? product.defaultImage;
  }, [product, color]);

  console.log(image);

  return (
    <Flex
      alignSelf="flex-start"
      position={{ base: "sticky", mdDown: "static" }}
      top="0"
    >
      <Image width="lg" fit="contain" src={image} alt={product.title} />
    </Flex>
  );
};

export default ProductInfo;
